import SafeairManager from "../../util/api/SafeairManager";
import { APIs } from "../../util/api/APIs";

export default class FitToFlyService {
  static async submitAssessment(passengerId, fitToFlyData) {
    try {
      const response = await SafeairManager.invoke({
        api: APIs.FitToFly.SubmitAssessment,
        parameters: {
          passengerId: passengerId,
        },
        body: fitToFlyData,
      });
      return response.data;
    } catch (error) {
      console.error("Error submitting Fit-to-Fly Assessment:", error);
      throw error;
    }
  }

  static async getAssessmentByPassenger(passengerId) {
    try {
      const response = await SafeairManager.invoke({
        api: APIs.FitToFly.GetAssessmentByPassenger,
        parameters: {
          passengerId: passengerId,
        },
        body: null,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching Fit-to-Fly Assessment:", error);
      throw error;
    }
  }
}
